/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Unavailable_MessageInputs */

const en_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video filters are not available for YouTube & Vimeo content.`)
};

const fr_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les filtres video ne sont pas disponibles pour le contenu YouTube et Vimeo.`)
};

const de_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für YouTube- und Vimeo-Inhalte stehen keine Videofilter zur Verfügung.`)
};

const it_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I filtri video non sono disponibili per i contenuti di YouTube e Vimeo.`)
};

const ru_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеофильтры недоступны для контента YouTube и Vimeo.`)
};

const es_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los filtros de vídeo no están disponibles para el contenido de YouTube y Vimeo.`)
};

const zh_cn2_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 和 Vimeo 内容不支持视频滤镜功能。`)
};

const ja_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ フィルターは YouTube および Vimeo コンテンツでは使用できません。`)
};

const hi_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube और Vimeo पर उपलब्ध सामग्री के लिए वीडियो फ़िल्टर उपलब्ध नहीं हैं।`)
};

const pt_pt2_video_filters_unavailable_message = /** @type {(inputs: Video_Filters_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os filtros de vídeo não estão disponíveis para conteúdo do YouTube e do Vimeo.`)
};

/**
* | output |
* | --- |
* | "Video filters are not available for YouTube & Vimeo content." |
*
* @param {Video_Filters_Unavailable_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_unavailable_message = /** @type {((inputs?: Video_Filters_Unavailable_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Unavailable_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_unavailable_message(inputs)
	if (locale === "de") return de_video_filters_unavailable_message(inputs)
	if (locale === "it") return it_video_filters_unavailable_message(inputs)
	if (locale === "ru") return ru_video_filters_unavailable_message(inputs)
	if (locale === "es") return es_video_filters_unavailable_message(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_unavailable_message(inputs)
	if (locale === "ja") return ja_video_filters_unavailable_message(inputs)
	if (locale === "hi") return hi_video_filters_unavailable_message(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_unavailable_message(inputs)
	return en_video_filters_unavailable_message(inputs)
});